// extracted by mini-css-extract-plugin
module.exports = {"codeBlock":"c_t7Qg2","code":"PS9otL","codeCopied":"BRFts1","codeButtonText":"c41zqUV","copyLogo":"c0v6QYw","checkLogo":"xEgVNt","codeLabelPrefix":"Y2JWZD"};